import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Modal, Popup, Table, Loader, Icon} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import InvoiceDetailsTable from './invoiceDetailsTable';

const {
  fetchPartsImportsInvoiceDetails,
  setTimerRequest,
} = Actions;

export const InvoiceDetailsModal = ({partImportInvoiceCode, partialInvoiceCode}) => {
  const [filtered, setFiltered] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.partsImportsInvoices.loadingDetails);
  const invoiceDetails = useSelector((state) => state.partsImportsInvoices.invoiceDetails);

  const changeFilteredData = (filteredRows) => {
    setFiltered(filteredRows);
  };

  const openDetailsModal = (e) => {
    e.preventDefault();
    setOpen(true);
    dispatch(setTimerRequest(false));
    dispatch(fetchPartsImportsInvoiceDetails(partImportInvoiceCode));
  };

  const closeDetailsModal = (e) => {
    e.preventDefault();
    dispatch(setTimerRequest(true));
    setOpen(false);
  };

  return (
    <Modal size='fullscreen' className='technician-assignment-modal'
      onOpen={(e) => openDetailsModal(e)}
      onClose={(e) => closeDetailsModal(e)}
      open={open}
      trigger={
        <span className='link'>
          <Popup
            trigger={<b>{partialInvoiceCode || partImportInvoiceCode}</b>
            }
            content='Ver detalle'
            position='top right'
            inverted
          />
        </span>
      }>

      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>Detalle de partes: {partImportInvoiceCode}</h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => closeDetailsModal(e)} />
        </div>
      </Modal.Header>
      
      <Modal.Content centered={false}>
        <div className='modal-background'>
          <div className='modal-overlay'>
            {loading ?
              <Table>
                <Table.Body>
                  <Table.Row className='loader'>
                    <Table.Cell colSpan='100%'>
                      <Loader active inline='centered' />
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table> :
              <InvoiceDetailsTable tableData={invoiceDetails}
                setFilteredData={changeFilteredData.bind(this)} filteredData={filtered} />
            }
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
};
